import Component from "../../js/assets/component.js"
import Device from "../../js/assets/device.js"
import WindowScroll from "../../js/assets/window_scroll.js"
import BgYoutubeMovie from "./atoms/media/bg_youtube_movie.js"
import LargeSlideshow from "./organisms/lp/large_slideshow.js"
import LpTitle from "./organisms/lp/lp_title.js"
import LpDetailBlockList from "./organisms/lp/lp_detail_block_list.js"
import ButtonTourDetail from "./organisms/lp/button_tour_detail.js"
import ButtonTourLP from "./organisms/lp/button_tour_lp.js"
import TourList from "./organisms/tour_list/tour_list.js"
import Header from "./organisms/common_block/header.js"

class TourLP extends Component {
  constructor(el){
    super(el)
  }

  data(){
    return {
      "showTourList": false,
      "device_mode": null,
      "scrollTop": null,
      "stopMainImage": null,
      "lpBodyScrollTop": null
    }
  }

  changed(){
    return {
      "showTourList": (val, prev)=>{
        if(val === true){
          this.tourList.activate()
          this.buttonTourLP.activate()
          this.buttonTourDetail.inActivate()
          this.lpDetailBlockList.inActivate()
        }else{
          this.buttonTourDetail.activate()
          this.lpDetailBlockList.activate()
          this.tourList.inActivate()
          this.buttonTourLP.inActivate()
        }
      },
      "device_mode": (val, prev)=>{
        if(val === "sp" && this.$data.showTourList !== true){
          this.title.activate()
        }

        //switch largeslideshow or bgmovie
        if(this.$data.device_mode === "sp"){
          this.largeSlideShow.activate()
          this.bgYoutubeMovie.$data.active = false
        }else if(this.bgYoutubeMovie.$el.length!==0 && this.$data.device_mode !== "sp"){
          this.largeSlideShow.inActivate()
          this.bgYoutubeMovie.$data.active = true
          if(this.stopMainImage === false){
            this.bgYoutubeMovie.play()
          }
        }else{
          this.largeSlideShow.activate()
          this.bgYoutubeMovie.$data.active = false
          this.bgYoutubeMovie.pause()
        }
      },
      "scrollTop": (val, prev)=>{
        if(WindowScroll.scrollTop > this.$data.lpBodyScrollTop){
          this.$data.stopMainImage = true
        }else{
          this.$data.stopMainImage = false
        }
      },
      "stopMainImage": (val)=>{
        if(this.$data.device_mode === "sp"){
          if(val === true){
            this.largeSlideShow.clearSlideTimer()
          }else{
            this.largeSlideShow.startSlideTimer()
          }
          this.bgYoutubeMovie.pause()
        }else if(this.bgYoutubeMovie.$el.length!==0 && this.$data.device_mode !== "sp"){
          if(val === true){
            this.bgYoutubeMovie.pause()
          }else{
            this.bgYoutubeMovie.play()
          }
          this.largeSlideShow.clearSlideTimer()
        }else{
          if(val === true){
            this.largeSlideShow.clearSlideTimer()
          }else{
            this.largeSlideShow.startSlideTimer()
          }
          this.bgYoutubeMovie.pause()
        }
      }
    }
  }

  async scrollToTitle(){
    // let scrollTop = this.title.$el.offset().top
    let scrollTop = this.$lpBody.offset().top - Header.$el.height() - Header.$el.height()/3
    await WindowScroll.scrollTo({
      scrollTop: scrollTop,
      duration: 1500,
      easing: "easeInOutQuart"
    })
  }

  async scrollToTourList(){
    let scrollTop = this.tourList.$el.offset().top
    await WindowScroll.scrollTo({
      scrollTop: scrollTop,
      duration: 1500,
      easing: "easeInOutQuart"
    })
  }

  mounted() {
    var self = this

    Device.addEventListener("device_mode", (data) => {
      this.$data.device_mode = data
    })
    WindowScroll.addEventListener("scrollTop", (data) => {
      this.$data.scrollTop = data.scrollTop
    })

    //title
    this.title = new LpTitle(this.$el.find(".lp_title").get(0))

    //body
    this.$lpBody = this.$el.find(".lp_body")
    this.$data.lpBodyScrollTop = this.$lpBody.offset().top
    window.addEventListener("resize", ()=>{
      this.$data.lpBodyScrollTop = this.$lpBody.offset().top
      // this.checkStopMainImage(WindowScroll.scrollTop)
    })

    //lpDetailBlockList
    this.lpDetailBlockList = new LpDetailBlockList(this.$el.find("#lpDetailBlockList").get(0));
    this.lpDetailBlockList.addEventListener("activeIndex", async (data)=>{
        await this.scrollToTitle()
    }, 0)

    //buttonTourDetail
    this.buttonTourDetail = new ButtonTourDetail(this.$el.find("#buttonTourDetail").get(0))
    this.buttonTourDetail_1 = new ButtonTourDetail(this.$el.find("#buttonTourDetail-1").get(0))
    this.buttonTourDetail.$el.on("click", ()=>{
      this.$data.showTourList = true
      return false
    })
    this.buttonTourDetail_1.$el.on("click", ()=>{
      // this.$data.showTourList = true
      if(Device.$data.device_mode === "pc"){
        this.scrollToTourList()
      }else{
        this.$data.showTourList = true
      }
      return false
    })

    //ButonTourLP
    this.buttonTourLP = new ButtonTourLP(this.$el.find("#buttonTourLP").get(0))
    this.buttonTourLP.$el.on("click", ()=>{
      this.$data.showTourList = false
      return false
    })

    //TourList
    this.tourList = new TourList(this.$el.find("#tourList").get(0))

    //
    this.addEventListener("showTourList", async (data)=>{
      if(data === true){
        this.title.inActivate()
        await this.scrollToTitle()
      }else if(this.lpDetailBlockList.$data.activeIndex !== 0){
        this.title.activate()
        this.lpDetailBlockList.$data.activeIndex = 0
      }else{
        this.title.activate()
        await this.scrollToTitle()
      }
    }, 0)

    //LargeSlideshow
    this.largeSlideShow = new LargeSlideshow(this.$el.find(".largeSlideShow").get(0))

    //bgMovie
    this.bgYoutubeMovie = new BgYoutubeMovie(this.$el.find("#bgYoutubeMovie").get(0))

    //device_mode
    this.$data.device_mode = Device.$data.device_mode

    //スクロールイベントを発生させる
    window.scrollBy(0, 1)
  }
}

const tourLP = new TourLP("#landingPage")
export default tourLP
